const lottie = require('lottie-web');

const moduleName = 'animatedWork';

module.exports = () => {

    Array.from(document.querySelectorAll('.js-animated-work')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const holder = self;
        const params = {
            container: holder,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: holder.dataset.path
        };
        const anim = lottie.loadAnimation(params);

        anim.play();
    });

};